import styled from "@emotion/styled";
import { COLORS } from "../../header/header.styled";
import { fontStack, MutedText } from "../account/account-settings.styled";

/** existing exports (unchanged values) */
export const DescriptionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  ${fontStack};
  color: ${COLORS.textMuted};
  font-size: 14px;
`;

export const PastDue = styled.p`
  margin: 0;
  padding: 2px 8px;
  background: #2b2d33;
  border-radius: 20px;
  ${fontStack};
  color: #d65f46;
  font-size: 11px;
  cursor: pointer;
  width: fit-content;
  line-height: 140%;
  font-weight: 500;
`;

export const Paid = styled.p`
  margin: 0;
  padding: 2px 8px;
  background: #2b2d33;
  border-radius: 20px;
  ${fontStack};
  color: #5e84ed;
  font-size: 11px;
  cursor: pointer;
  width: fit-content;
  font-weight: 500;
  line-height: 140%;
`;

export const BulletItem = styled.li`
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
    line-height: 1.4;
    color: ${COLORS.textMuted};

    &::before {
        content: "";
        display: inline-block;
        background-image: url("/checkmark.svg");
        background-size: contain;
        background-repeat: no-repeat;
        width: 16px;
        height: 16px;
        margin-right: 8px;
        margin-top: 4px;
        flex-shrink: 0;
    }
`;

/** new helpers to remove inline styles (no value changes) */
export const Row = styled.div`
    display: flex;
    flex-direction: row;
`;

export const SpaceBetweenRow = styled(Row)`
    align-items: center;
    justify-content: space-between;
`;

export const Column = styled.div<{ $align?: string; $gap?: string }>`
    display: flex;
    flex-direction: column;
    align-items: ${({ $align }) => $align || "stretch"};
    gap: ${({ $gap }) => $gap || "0px"};
`;

export const Divider = styled.div`
    border-bottom: 1px solid #2b2d33;
`;

export const ActionRow = styled.div`
    display: flex;
    justify-content: space-between;
    // padding: 20px;
    height: 44px;
`;

export const MetaRow = styled(Row)`
    padding: 4px 0px;
    justify-content: space-between;
`;

export const FeatureListWrap = styled.div`
    /* wrapper keeps layout intent clear */
`;

export const BadgeWrap = styled.div`
    display: flex;
    flex-direction: column;
`;

export const DownloadLink = styled(MutedText)`
    font-size: 11px;
    cursor: pointer;
`;

export const DetailLabel = styled(MutedText)`
    font-size: 13px;
    font-weight: 500;
    line-height: 100%;
`;

export const DetailValue = styled(MutedText.withComponent("p"))`
    font-size: 15px;
`;

export const TrialSpan = styled.span`
    background: #3a2f1e;
    border-radius: 12px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 11px;
    leading-trim: NONE;
    line-height: 140%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #e1c27a;
    width: 55px;
    height: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
`;
